import React from 'react';
import { VarianceBadge } from './variance-badge';

type OverUnderMetricProps = {
  title: string;
  actualValue: string;
  plannedValue: string;
  variance: number;
  varianceFormatted: string;
  favorableDirection: 'over' | 'under';
};

export function ActiveOverUnderMetric({
  title,
  actualValue,
  plannedValue,
  variance,
  varianceFormatted,
  favorableDirection
}: OverUnderMetricProps) {
  return (
    <div className="flex flex-col gap-2 grow">
      <span className="text-sm font-medium text-gray-800">{title}</span>
      <div className="flex items-baseline gap-3">
        <span className="text-lg font-semibold text-[#181d1f]">{actualValue}</span>
        <div className="flex items-baseline gap-2">
          <VarianceBadge
            value={variance}
            formattedValue={varianceFormatted}
            favorableDirection={favorableDirection}
          />
          <span className="text-xs text-gray-800">/ {plannedValue} plan</span>
        </div>
      </div>
    </div>
  );
}

export function ExpiredOverUnderMetric({
  title,
  actualValue,
  plannedValue,
  variance,
  varianceFormatted,
  favorableDirection
}: OverUnderMetricProps) {
  return (
    <div className="flex flex-col gap-2 grow">
      <span className="text-sm font-medium text-gray-800">{title}</span>
      <span className="text-lg font-semibold text-[#181d1f]">{actualValue}</span>
      <div className="flex items-baseline gap-2">
        <VarianceBadge
          value={variance}
          formattedValue={varianceFormatted}
          favorableDirection={favorableDirection}
        />
        <span className="text-xs text-gray-800">/ {plannedValue} plan</span>
      </div>
    </div>
  );
}
